import React from 'react';

import frFR from 'antd/lib/locale/fr_FR';
import { Moment } from 'moment/moment';

import {
  NotificationInfosRequestDto,
  NotificationInfosViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { DatePicker } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { generateNotificationInfosRequestDto } from 'pages/forces-de-l-ordre/PageDossier/Actions/InfosNotification/utils';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';
import { DATE_FORMAT } from 'utils/formats';

import {
  DATE_DE_RETOUR,
  NotificationInfos,
  NotificationInfosFieldsProps,
  notificationManuelleInfosEnumMapping,
  validateNotificationInfosRule,
} from '../utils';

function DatePickerRetour({
  values,
  dossierId,
}: NotificationInfosFieldsProps): React.ReactElement {
  const foController = useApi().ForceOrdreControllerApi;
  const key: keyof NotificationInfos = 'dateRetour';
  return (
    <DatePicker
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label:
            values.etatDistribution === undefined
              ? DATE_DE_RETOUR
              : notificationManuelleInfosEnumMapping[values.etatDistribution]
                  .libelleDateRetour,
          rules: [
            {
              validator: async (
                _rule,
                value: Moment | undefined,
              ): Promise<void> => {
                const sortieVehiculeRequestDto: NotificationInfosRequestDto =
                  generateNotificationInfosRequestDto({
                    ...values,
                    [key]: value,
                  });
                return await validateNotificationInfosRule(
                  dossierId,
                  foController,
                  sortieVehiculeRequestDto,
                  NotificationInfosViolationDtoFormFieldEnum.DATE_RETOUR,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      datePickerProps={{
        style: { width: '100%' },
        placeholder: FormPlaceholders.Date,
        format: DATE_FORMAT,
        locale: frFR.DatePicker,
      }}
    />
  );
}

export default DatePickerRetour;
